import React from 'react';
import { X, Sparkles } from 'lucide-react';

const OnboardingPrompt = ({ onStart, onDismiss }) => {
  return (
    <div className="bg-gradient-to-r from-purple-600 to-indigo-600 rounded-xl p-4 mb-4 shadow-lg">
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0">
          <div className="w-10 h-10 bg-white/20 rounded-full flex items-center justify-center">
            <Sparkles className="w-5 h-5 text-white" />
          </div>
        </div>
        
        <div className="flex-1">
          <h3 className="text-white font-semibold text-lg">
            Unlock your best streaming deals
          </h3>
          <p className="text-purple-100 text-sm mt-1">
            Complete your profile to discover hidden perks, credits, and savings you might be missing.
          </p>
          
          <div className="flex flex-wrap gap-2 mt-3">
            <button
              onClick={onStart}
              className="px-4 py-2 bg-white text-purple-700 font-semibold rounded-lg hover:bg-purple-50 transition-colors"
            >
              Complete Profile
            </button>
            <button
              onClick={onDismiss}
              className="px-4 py-2 bg-white/10 text-white font-medium rounded-lg hover:bg-white/20 transition-colors"
            >
              Later
            </button>
          </div>
        </div>
        
        <button
          onClick={onDismiss}
          className="flex-shrink-0 p-1 text-purple-200 hover:text-white transition-colors"
          aria-label="Dismiss"
        >
          <X className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default OnboardingPrompt;